<script>
    import { fade } from 'svelte/transition';
    import { scale } from 'svelte/transition';
    import UserStore from '../stores/user';
    import fetchData from '../api.js';
    import { push , link , replace} from 'svelte-spa-router'
    import { _ } from 'svelte-i18n';

    let email;
    let password;
    let name;
    let error = '';

    localStorage.setItem('user','{}')

    const handleSubmit = async () => {

      const agentName = (name || '').trim();
      if (agentName === '') {
        error = 'Please enter your name';
        return;
      }

        let formData = {
            email : email,
            password : password,
            action : 'login',
        }       

        const data = await fetchData(formData);
        if (data.success==1) {

            formData = {
                action : 'w_get_shipping_companies',
            }       

            const dataPlatforms = await fetchData(formData);
            if (dataPlatforms.success==1) {
              platforms = dataPlatforms.data;
              localStorage.setItem('platforms',JSON.stringify(platforms));        
            } else {
              localStorage.setItem('platforms','{}');   
            }

            localStorage.setItem('stores','[]');

            let user = data;
            user.agent_name = agentName;

            console.log(user);
           
            localStorage.setItem('user',JSON.stringify(user))

            UserStore.update(currentUser => {
                return user;
            });


            if ($UserStore?.erp == 1) {

              formData = {
                token : user.data,
                action : 'w_get_erp_companies',
              }       

              const dataErpPlatforms = await fetchData(formData);
              if (dataErpPlatforms.success==1) {
                erp_platforms = dataErpPlatforms.data;
                localStorage.setItem('erp_platforms',JSON.stringify(erp_platforms));        
              } else {
                localStorage.setItem('erp_platforms','{}');   
              }

            }
           

            // if ($UserStore.settings 
            //   && $UserStore.settings.shipping_settings 
            //   && $UserStore.settings.shipping_settings.shipping_method ) {

            //     shipping_push_supplier = $UserStore.settings.shipping_settings.shipping_method[0].shipping_push_supplier

            // }


            push('/agents/products');

        } else {
            error = $_('login.error');
        }


    }

</script>
<style>

h1 {
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;;

}
h2 {
  font-size:15px;
  font-weight: normal;
  text-align: center;
  margin: auto;
  margin-top: 0;;
  max-width: 250px;;
  
}


.login-form {
  align-items: center;
  padding: 0 20px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  justify-content: center;
  display: flex;
  flex-direction: column;  
}

.login-form input[type="text"] ,
.login-form input[type="password"],
.login-form input[type="text"]::placeholder  ,
.login-form input[type="password"]::placeholder  {
  margin: 9px 0;
  padding: 10px 0;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #000;
  box-sizing: border-box;
  font-size: 15px;
  color: #000;
}

.login-form input[type="text"] ,
.login-form input[type="password"] {
  border-radius: 7px;
  border: 1px solid #d0d0d0;
  padding:10px 20px;
  text-align: right;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
}


.login-form label {
  margin-top: 10px;
  float: right;
}

.login-button {

  background-color: var(--theme-one-color);
  border-radius: 30px;
  color: #fff;
  border: 1px solid #eee;
  padding: 15px 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: auto;
  font-size: 14px;
  margin-top: 20px;;
}

.login-button:hover {
  background-color: var(--theme-one-color);
  color: white;
}
.login-button.disabled {
  background-color: #DBDBDB;
  color: #979797;
}

.error {
    color: white;
    font-size:13px;
    background-color: var(--theme-one-color);
    border-radius:10px;
    padding:5px 10px;
    margin:10px 0 0;
}
.logo {
  display: flex;
  justify-content: center;
  margin:20px 0 40px;;
}

.logo img{
  width:130px;
}

@media (min-width:699px) {   
  


  .login-grid {
    display: flex;
    flex-direction: row-reverse;
    margin: auto;
    margin-top: 80px;
    max-width: 380px;
    width: 100%;
    box-shadow: 1px 1px 100px #d8d8d8;
    border-radius: 30px;
    padding: 40px 20px;
    
  }
  
  .login-grid-con {

    flex:1;

  }
  .login-title {
      font-size: 25px;
  }

  
}

</style>
<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <div class="page">    
      <div class="login-grid">


        <div class="login-grid-con">
          <div class="login-grid-con-pad">

            {#if shippingo=="1"}
            <div class="text-center logo"><img src="{siteUrl}images/0.svg"></div>
            {/if}
            {#if shippingo=="2"}
            <div class="text-center logo"><img src="{siteUrl}images/datalogics.svg"></div>
            {/if}
        
            <h1 class="login-title">{$_('login.welcome')}</h1>
            <h2>{$_('login.welcome_sub')}</h2>
          
            <form id="login-form" class="login-form" on:submit|preventDefault={handleSubmit}>
              <input type="text" placeholder="Name" required bind:value={name}>
              <input type="text" placeholder="{$_('login.email')}" required bind:value={email}>
              <input type="password" placeholder="{$_('login.password')}" required bind:value={password}>
              <div class:error={error!==''} in:scale>{error}</div>
              <button type="submit" class="login-button">{$_('login.login')}</button>
            </form>
            {#if shippingo=="1" || shippingo=="2"}
            <a class="text-center block mt-4 underline" href="/register" use:link>{$_('login.dont_have_account_reg')}</a>
            {/if}
          
          </div>

        </div>

      </div>

    </div>
</div>
